var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
var Container = exports.Container = _react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
    fullWidth = _ref.fullWidth,
    testID = _ref.testID,
    containerStyle = _ref.containerStyle,
    isFake = _ref.isFake;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  return (0, _jsxRuntime.jsx)(_reactNative.View, {
    ref: ref,
    style: [fullWidth && styles.fullWidth, containerStyle],
    testID: testID,
    pointerEvents: isFake ? "none" : undefined,
    children: children
  });
});